import { useQuery } from "@tanstack/react-query";
import { GET_MY_PROGRAMS, getMyPrograms } from "..";

export const useProgramListQuery = () => {
  return useQuery({
    queryKey: [GET_MY_PROGRAMS],
    queryFn: getMyPrograms,
  });
};
